import { Chip } from "@mui/material";
import ToolTip from "../../../ToolTip/ToolTip";

export const CRM_Batch_View_Table_Head = [
  {
    field: "sl_no",
    minWidth: 100,
    headerName: "Sl No",
  },
  {
    field: "course_batch_id",
    minWidth: 100,
    headerName: "Batch ID",
  },
  {
    field: "course_batch_name",
    minWidth: 250,
    headerName: "Batch Name",
    renderCell: (params) => {
      return (
        <ToolTip
          content={`${params.row.course_batch_name} - (${params.row.course_batch_serial_no})`}
          expand={`${params.row.course_batch_name} - (${params.row.course_batch_serial_no})`}
        />
      );
    },
  },
  {
    field: "course_batch_capacity",
    minWidth: 150,
    headerName: "Capacity",
  },
  {
    field: "course_batch_start_date",
    minWidth: 200,
    headerName: "Start Date",
  },
  {
    field: "course_batch_start_time",
    minWidth: 200,
    headerName: "Start Time",
  },
  {
    field: "course_batch_end_time",
    minWidth: 200,
    headerName: "End Time",
  },
  {
    field: "cro_assigned_on",
    minWidth: 200,
    headerName: "CRO Assigned On",
    renderCell: (params) => {
      return params.row.cro_assigned_on === null
        ? "Not Assigned"
        : params.row.cro_assigned_on;
    },
  },
  {
    field: "AssignedTo",
    minWidth: 200,
    headerName: "Assigned CRO",
    renderCell: (params) => {
      return params.row.AssignedTo === null
        ? "Not Assigned"
        : params.row.AssignedTo;
    },
  },
  {
    field: "AssignedBy",
    minWidth: 200,
    headerName: "Assigned CRM",
  },
  {
    field: "AssignedSME",
    minWidth: 200,
    headerName: "Assigned SME",
    renderCell: (params) => {
      if (params.row.AssignedSME === null) {
        return (
          <Chip
            color="primary"
            label={"Not Assigned"}
            size="small"
            variant="outlined"
          />
        );
      } else {
        return params.row.AssignedSME;
      }
    },
  },
  {
    field: "AssignedSMO",
    minWidth: 200,
    headerName: "Assigned SMO",
  },
  {
    field: "createdBy",
    minWidth: 200,
    headerName: "Created By",
  },
  {
    field: "courseAvailable",
    minWidth: 250,
    headerName: "Course",
    renderCell: (params) => {
      return (
        <ToolTip
          expand={params.row.courseAvailable}
          content={params.row.courseAvailable}
        />
      );
    },
  },
  {
    field: "className",
    minWidth: 150,
    headerName: "Class",
  },
  {
    field: "syllabusName",
    minWidth: 200,
    headerName: "Syllabus",
  },
  {
    field: "totalsessionandcompletedsession",
    minWidth: 200,
    headerName: "Completed Sessions / Total Sessions",
    renderCell: (params) => {
      return `${params.row.completedSessions} / ${params.row.totalSessions}`;
    },
  },
  {
    field: "courseBatchStatus",
    minWidth: 200,
    headerName: "Status",
    renderCell: (params) => {
      if (params.row.courseBatchStatus === "Active") {
        return (
          <Chip
            color="primary"
            label="Active"
            size="small"
            variant="outlined"
          />
        );
      } else if (params.row.courseBatchStatus === "Temporary Inactive") {
        return (
          <Chip
            color="warning"
            label="Temporary Inactive"
            size="small"
            variant="outlined"
          />
        );
      } else if (params.row.courseBatchStatus === "Upcoming") {
        return (
          <Chip
            color="secondary"
            label="Upcoming"
            size="small"
            variant="outlined"
          />
        );
      } else {
        return (
          <Chip
            color="success"
            label="Completed"
            size="small"
            variant="outlined"
          />
        );
      }
    },
  },
];
